var React = require('react');

function IconCoupons (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.7317 8.20028L7.95609 16.8552C7.75732 17.051 7.4393 17.0477 7.24384 16.8486L0.184292 9.6671C-0.0641667 9.41489 -0.060854 9.01002 0.190918 8.76444L8.86379 0.215709C9.00624 0.0763279 9.19507 0 9.39384 0L16.3673 0.0530977C16.7184 0.0564163 17 0.341816 17 0.696907L16.9437 7.69585C16.9437 7.88169 16.8675 8.06421 16.7317 8.20028ZM13.2897 2.24338C12.4714 2.23674 11.8022 2.89714 11.7956 3.71684C11.789 4.53653 12.4482 5.20689 13.2665 5.21353C14.0847 5.22017 14.7539 4.55977 14.7606 3.74007C14.7672 2.92037 14.1079 2.25002 13.2897 2.24338Z"}));
}

IconCoupons.defaultProps = {"viewBox":"0 0 17 17","fill":"none"};

module.exports = IconCoupons;

IconCoupons.default = IconCoupons;
